import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { Toasts } from "common/components/Toasts";
import { ErrorBoundary } from "common-components";
import hireartLogo from "../assets/images/hireart-logo-primary-green-neutral.svg";
import "../../Common/css/layout.css";

const LoginNavLayout = ({ children }) => {
  const location = useLocation();
  const errorResetKey = location.pathname;

  return (
    <div className="Site overflow-hidden">
      <header className="border-b border-solid border-neutral-20 bg-neutral-10 px-24 py-16">
        <a href="/">
          <img alt="HireArt" className="h-32" src={hireartLogo} />
        </a>
      </header>

      <div className="Site-content candidates flex items-start justify-center sm:items-center sm:px-16 sm:py-0">
        <ErrorBoundary key={errorResetKey}>
          <div className="w-full max-w-md">{children}</div>
        </ErrorBoundary>
      </div>
      <Toasts.Container />
    </div>
  );
};

LoginNavLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { LoginNavLayout };
